module.exports = __webpack_public_path__ + "media/images/payments/jcb-504c3af97de8c7fc739e4c02def07cc7.svg";